<template>
    <div v-if="notification?.show" class="fixed-notification d-flex color-white">
        <div>
            <img v-if="notification.type === 'success'" :src="require('@/assets/pep/HappyFace.png')" alt="" />
        </div>
        <div class="flex-fill-y ion-justify-content-center ion-align-items-center ion-padding-horizontal bold">
            <p class="ion-no-margin color-white font-18">{{ notification.message }}</p>
            <div v-if="notification.link && notification.linkText" class="mt-4">
                <a :href="notification.link" class="color-white">{{ notification.linkText }}</a>
            </div>
        </div>
        <div class="d-flex ion-align-items-center ion-justify-content-center ion-margin-horizontal">
            <ion-button @click="hide" size="large" fill="clear" class="ion-no-padding">
                <ion-icon :icon="close" size="large" color="light" />
            </ion-button>
        </div>
    </div>
</template>

<script lang="ts">
import { IonButton, IonIcon } from '@ionic/vue';
import { computed, defineComponent } from 'vue';
import { close } from 'ionicons/icons';
import { useStore } from 'vuex';

export default defineComponent({
    setup() {
        const store = useStore();

        const notification = computed(() => store.getters.getNotification);

        const hide = () => {
            store.dispatch('hideNotification');
        };

        return {
            notification,
            hide,
            close,
        };
    },
    components: {
        IonButton,
        IonIcon,
    },
});
</script>

<style scoped>
.fixed-notification {
    background-color: var(--ion-color-success-shade);
    padding-left: 5px;
    padding-right: 5px;
}

@media screen and (min-width: 960px) {
    .fixed-notification {
        max-width: 600px;
        border-radius: 6px;
        margin: 8px auto;
    }
}

.fixed-notification img {
    width: 120px;
    height: auto;
    margin-bottom: -15px;
    margin-top: -10px;
}

.fixed-notification h4 {
    margin-bottom: 4px;
}
</style>
